import { ComponentProps } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import { notify } from 'app/developer-v3/store/shared/actions';
import { saveServiceUpdates } from 'app/developer-v3/Actions';
import {
  ACTION_TYPES,
  NEW_SERVICE_FIELD,
  SERVICE_TYPE,
} from 'app/developer-v3/constants';
import {
  createNewService,
  deleteSearchOrCreate,
  saveSearchOrCreate,
} from 'app/developer-v3/store/build/actions';
import {
  selectCurrentService,
  selectIsAppVersionSaving,
  selectServicesByType,
} from 'app/developer-v3/store/build/selectors';

import ActionSettings from './ActionSettings';

const mapStateToProps = (state, ownProps) => {
  const { params } = ownProps;

  const isActionNew = params.actionKey === NEW_SERVICE_FIELD;
  const type = params.actionType;

  const searchOrCreates = selectServicesByType(
    SERVICE_TYPE.searchOrCreates,
    state
  );
  const action = selectCurrentService(state);
  // A searchOrCreate is keyed with a search action's key.
  const searchOrCreate =
    type === ACTION_TYPES.searches
      ? searchOrCreates?.[params.actionKey]
      : undefined;
  const hasPerform =
    !!action?.operation?.perform?.url && !!action?.operation?.perform?.source;

  return {
    creates: selectServicesByType(SERVICE_TYPE.creates, state),
    hasPerform,
    initialSettings: {
      description: action?.display?.description ?? '',
      hidden: action?.display?.hidden ?? false,
      isEnabledSearchOrCreate:
        type === ACTION_TYPES.searches ? !!searchOrCreate : undefined,
      key: action?.key ?? '',
      label: action?.display?.label ?? '',
      noun: action?.noun ?? '',
      searchOrCreateCreateKey: searchOrCreate?.create,
      searchOrCreateLabel: searchOrCreate?.display.label,
      type,
    },
    isActionFound: !isEmpty(action),
    isActionNew,
    isSaving: selectIsAppVersionSaving(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  async onSubmit(
    settingsNext: ComponentProps<typeof ActionSettings>['initialSettings']
  ) {
    return dispatch(async (_dispatch, getState) => {
      const { actionKey, actionType } = ownProps.params;
      const isActionNew = actionKey === NEW_SERVICE_FIELD;

      if (isActionNew) {
        await dispatch(
          createNewService(actionType, {
            display: {
              description: settingsNext.description,
              hidden: settingsNext.hidden,
              label: settingsNext.label,
            },
            key: settingsNext.key,
            noun: settingsNext.noun,
          })
        );
      }

      const state = getState(dispatch);
      const action = selectCurrentService(state);

      if (settingsNext.type === ACTION_TYPES.searches) {
        if (settingsNext.isEnabledSearchOrCreate) {
          if (
            settingsNext.searchOrCreateCreateKey &&
            settingsNext.searchOrCreateLabel
          ) {
            await dispatch(
              saveSearchOrCreate({
                create: settingsNext.searchOrCreateCreateKey,
                display: {
                  // TODO: Add a dedicated input field in UI for this
                  // description rather than reusing reuse the search action's
                  // description.
                  description: settingsNext.description,
                  label: settingsNext.searchOrCreateLabel,
                },
                key: settingsNext.key,
                search: settingsNext.key,
              })
            );
          }
        } else {
          const searchOrCreates = selectServicesByType(
            SERVICE_TYPE.searchOrCreates,
            state
          );
          const searchOrCreate = searchOrCreates?.[settingsNext.key];
          if (searchOrCreate) {
            await dispatch(deleteSearchOrCreate(settingsNext.key));
          }
        }
      }

      if (!isActionNew) {
        const isSuccess = await dispatch(
          saveServiceUpdates(actionType, {
            ...action,
            display: {
              description: settingsNext.description,
              hidden: settingsNext.hidden,
              label: settingsNext.label,
            },
            key: settingsNext.key,
            noun: settingsNext.noun,
          })
        );

        if (isSuccess) {
          dispatch(
            notify.success(`Action: ${settingsNext.key} has been updated!`)
          );
        }
      }
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionSettings);
